export default __webpack_public_path__ + "static/Digital_Spec_275x550_Artvizit.co eng-bad0ad5dc7770e34c4c5f2fd13602103.jpg";